import { KursInfoVO } from "@core/api/v1";
import TypEnum = KursInfoVO.TypEnum;

export const kursTitelMap: { [key in TypEnum]: string } = {
    ZERT_GUTACHTUNG_AUVA: 'ZERTIFIZIERUNG - Begutachtung in der Unfallversicherung',
    ZERT_PENSION: 'ZERTIFIZIERUNG Pensionsbegutachtung',
    REZERT_PENSION: 'REZERTIFIZIERUNG Pensionsbegutachtung',
    REZERT_PENSION_PSYCHIATRIE: '(RE-)ZERTIFIZIERUNG Pensionsbegutachtung, Fachgebiet Psychatrie',
    ZERT_PFLEGEGELD: 'ZERTIFIZIERUNG Pflegegeldeinstufung',
    ZERT_PFLEGEGELD_KINDER: 'ZERTIFIZIERUNG Pflegegeldeinstufung, Aufbaumodul Kinder und Jugendliche',
    REZERT_PFLEGEGELD: 'REZERTIFIZIERUNG Pflegegeldeinstufung'
};
